<template>
    <el-table :data="mytableData" stripe style="width: 100%" v-if="mytableData != null" :cell-style="{cellStyle,'text-align':'center'}">
        <el-table-column prop="sumResult1" label="和值" align="center"></el-table-column>
        <el-table-column prop="unOpenCount1" label="未开期数" align="center"></el-table-column>
        <el-table-column prop="sumResult2" label="和值" align="center"></el-table-column>
        <el-table-column prop="unOpenCount2" label="未开期数" align="center"></el-table-column>

    </el-table>
</template>
<script>
export default {
    data() {
        return {
            mytableData: [{
                sumResult1:"大",
                unOpenCount1:0,
                sumResult2:"小",
                unOpenCount2:0,
            },{
                sumResult1:"单",
                unOpenCount1:0,
                sumResult2:"双",
                unOpenCount2:0,
            },{
                sumResult1:"大单",
                unOpenCount1:0,
                sumResult2:"小单",
                unOpenCount2:0,
            },{
                sumResult1:"大双",
                unOpenCount1:0,
                sumResult2:"小双",
                unOpenCount2:0,
            },{
                sumResult1:"极小",
                unOpenCount1:0,
                sumResult2:"极大",
                unOpenCount2:0,
            },{
                sumResult1:"00",
                unOpenCount1:0,
                sumResult2:"14",
                unOpenCount2:0,
            },{
                sumResult1:"01",
                unOpenCount1:0,
                sumResult2:"15",
                unOpenCount2:0,
            },{
                sumResult1:"02",
                unOpenCount1:0,
                sumResult2:"16",
                unOpenCount2:0,
            },{
                sumResult1:"03",
                unOpenCount1:0,
                sumResult2:"17",
                unOpenCount2:0,
            },{
                sumResult1:"04",
                unOpenCount1:0,
                sumResult2:"18",
                unOpenCount2:0,
            },{
                sumResult1:"05",
                unOpenCount1:0,
                sumResult2:"19",
                unOpenCount2:0,
            },{
                sumResult1:"06",
                unOpenCount1:0,
                sumResult2:"20",
                unOpenCount2:0,
            },{
                sumResult1:"07",
                unOpenCount1:0,
                sumResult2:"21",
                unOpenCount2:0,
            },{
                sumResult1:"08",
                unOpenCount1:0,
                sumResult2:"22",
                unOpenCount2:0,
            },{
                sumResult1:"09",
                unOpenCount1:0,
                sumResult2:"23",
                unOpenCount2:0,
            },{
                sumResult1:"10",
                unOpenCount1:0,
                sumResult2:"24",
                unOpenCount2:0,
            },{
                sumResult1:"11",
                unOpenCount1:0,
                sumResult2:"25",
                unOpenCount2:0,
            },{
                sumResult1:"12",
                unOpenCount1:0,
                sumResult2:"26",
                unOpenCount2:0,
            },{
                sumResult1:"13",
                unOpenCount1:0,
                sumResult2:"27",
                unOpenCount2:0,
            }]
        }
    },
    props: {
        tableData: {
            type: Array,
            default: null,
            require: true
        }
    },
    created() {

       this.calcInterval()
       for(let i = 5; i < this.mytableData.length;i++)
       {
            this.mytableData[i].unOpenCount1 = this.calcSumNumInterval(Number(this.mytableData[i].sumResult1))
            this.mytableData[i].unOpenCount2 = this.calcSumNumInterval(Number(this.mytableData[i].sumResult2))
       }
    },
    methods: {
        cellStyle(row){
            if(row.column.label==="未开期数" )  return "color:red"
        },
        getResult(data) {
            let result = 0;
            data.forEach(element => {
                result += element
            });

            return result
        },
        isBigNum(data) {
          
            if (data.sumResult >= 14){ 
                
                return true
            }
         
            return false
        },
        isOddNumber(data) {
            if (data.sumResult == 0 || (data.sumResult % 2 == 0)) return false
        
            return true
        },
        isVerySmall(data){
            if (data.sumResult <=5 ) return true
            return false
        },
        isVersyBig(data){
            if (data.sumResult >=23 ) return true
            return false
        },
       
        calcInterval() {
            let bigInterval = 0
            let smallInterval = 0
            let oddInterval = 0
            let evenInterval = 0
            
            let bigOddInterval = 0
            let bigEvenInterval = 0

            let smallOddInterval = 0
            let smallEvenInterval = 0

            let verySmallInterval = 0
            let veryBigInterval = 0

            let findBig = true
            let findsmall = true
            let findodd = true
            let findeven = true
            let findBigOdd = true
            let findBigEven = true
            let findSmallOdd = true
            let findSmallEven = true

            let findVeryBig = true
            let findVerysmall = true
            console.log("I=",this.tableData)
            for (let i = 0; i < this.tableData.length; i++) {
               
                let item = this.tableData[i]
                if(!item || !item.sumResult){
                   
                    continue;
                }
            
                if (!item.head) {
                   
                    if (!this.isBigNum(item) && findBig) {
                        bigInterval++
                    } else {
                        findBig = false
                    }
                    
                    if (this.isBigNum(item) && findsmall) {
                        smallInterval++
                    } else {
                        findsmall = false
                    }
                    if (!this.isOddNumber(item) && findodd) {
                        oddInterval++
                    } else {
                        findodd = false
                    }
                    if (this.isOddNumber(item) && findeven) {
                        evenInterval++
                    } else {
                        findeven = false
                    }
                    if ((!this.isBigNum(item) || !this.isOddNumber(item)) && findBigOdd) {
                        bigOddInterval++
                    } else {
                        findBigOdd = false
                    }
                    if ((!this.isBigNum(item) || this.isOddNumber(item)) && findBigEven) {
                        bigEvenInterval++
                    } else {
                        findBigEven = false
                    }
                    if ((this.isBigNum(item) || !this.isOddNumber(item)) && findSmallOdd) {
                        smallOddInterval++
                    } else {
                        findSmallOdd = false
                    }
                    if ((this.isBigNum(item) || this.isOddNumber(item)) && findSmallEven) {
                        smallEvenInterval++
                    } else {
                        findSmallEven = false
                    }
                    if (!this.isVerySmall(item)  && findVerysmall) {
                        verySmallInterval++
                    } else {
                        findVerysmall = false
                    }
                    if (!this.isVersyBig(item)  && findVeryBig) {
                        veryBigInterval++
                    } else {
                        findVeryBig = false
                    }
                   
                    if (!findBig && !findsmall && !findodd && !findeven && !findBigOdd && !findBigEven && !findSmallOdd && !findSmallEven && !findVeryBig && !findVerysmall) {
                        break
                    }
                }
            }
            console.log("=!bigInterval==",bigInterval)
            this.mytableData[0].unOpenCount1 = bigInterval
            this.mytableData[0].unOpenCount2 = smallInterval

            this.mytableData[1].unOpenCount1 = oddInterval
            this.mytableData[1].unOpenCount2 = evenInterval

            this.mytableData[2].unOpenCount1 = bigOddInterval
            this.mytableData[2].unOpenCount2 = smallOddInterval

            this.mytableData[3].unOpenCount1 = bigEvenInterval
            this.mytableData[3].unOpenCount2 = smallEvenInterval

            this.mytableData[4].unOpenCount1 = verySmallInterval
            this.mytableData[4].unOpenCount2 = veryBigInterval
        },
        calcSumNumInterval(value){
            let resutl= 0
            for (let i = 0; i < this.tableData.length; i++) {
                let item = this.tableData[i]
                if (!item.head) {
                   
                     if(item.sumResult != value){
                        resutl++
                     }else{
                        break
                     }
                }
            }
            return resutl
        }
    }
}
</script>